import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';

/** The device's event stream. Placeholder until the content lands. */
export const DevicesDetailsEvents: React.FC = () => {
  const { t } = useI18n();
  return (
    <div className="modal-content tab-content">
      <p className="section-placeholder" data-testid="panel-events-placeholder">
        {t('devices.sectionComingSoon')}
      </p>
    </div>
  );
};
